/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lineNo: NonNullable<unknown> }} Line_NumberInputs */

const en_line_number = /** @type {(inputs: Line_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Line ${i?.lineNo}`)
};

/**
* | output |
* | --- |
* | "Line {lineNo}" |
*
* @param {Line_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const line_number = /** @type {((inputs: Line_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Line_NumberInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_line_number(inputs)
});